<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col md="12" lg="12" sm="6" class="px-0 pb-0">
          <v-btn
            fab
            x-small
            class="mx-2 mb-2"
            color="white"
            @click="$router.back()"
          >
            <v-icon light> mdi-arrow-left </v-icon>
          </v-btn>
          <!-- Main Container -->
          <!-- v-if="roleName == 'Employee' || roleName == 'Supervisor'" -->
          <v-card
            class="mt-4 mb-0 pb-0"
            rounded="xl"
            color="blue lighten-5"
            width="auto"
          >
            <!-- Dashboard Container -->
            <v-container fluid>
              <v-row class="ma-0">
                <v-col class="pa-0" style="min-width: 250px"
                  ><p class="py-3 text-subtitle-1">
                    Apply Other Request:
                  </p></v-col
                >
                <v-col class="pa-0">
                  <router-link to="/other-requests/create">
                    <v-btn color="white" dark fab>
                      <v-icon color="blue lighten1">mdi-plus</v-icon>
                    </v-btn>
                  </router-link>
                </v-col>
              </v-row>

              <!-- Category Cards -->
              <template v-if="other_requests.length > 0">
                <v-card
                  rounded="xl"
                  class="custom-border px-4 my-6"
                  elevation="10"
                  v-for="other_request in other_requests"
                  :key="other_request.id"
                >
                  <!-- :to="leave" -->
                  <router-link
                    :to="`/other-requests/${other_request.id}`"
                    style="text-decoration: none"
                  >
                    <v-row align="center" class="ma-0">
                      <v-col class="pa-0">
                        <span class="text-subtitle-1 font-weight-medium">
                          Date:
                        </span>
                        <br />
                        <span
                          class="text-subtitle-1 font-weight-medium black--text"
                        >
                          {{ other_request.date }}
                        </span>
                      </v-col>

                      <v-col class="pa-0">
                        <span class="text-subtitle-1 font-weight-medium">
                          Type:
                        </span>
                        <br />
                        <span
                          class="text-subtitle-1 font-weight-medium black--text"
                        >
                          {{ other_request.type }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="ma-0">
                      <v-col class="pa-0">
                        <span class="text-subtitle-1 font-weight-medium">
                          Description:
                        </span>
                        <br />
                        <span
                          class="text-subtitle-1 font-weight-medium black--text"
                        >
                          {{ other_request.description }}
                        </span>
                      </v-col>
                    </v-row>
                  </router-link>
                </v-card>
              </template>
              <template v-else>
                <v-row justify="center" class="pb-6">
                  <v-col align="center">
                    <span> No Other Requests Found.</span>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>
          <v-card
            v-if="roleName == 'Admin' || roleName == 'Supervisor'"
            class="mt-4 mb-0 pb-0"
            rounded="xl"
            color="blue lighten-5"
            width="auto"
          >
            <!-- Dashboard Container -->
            <v-container>
              <v-row class="ma-0">
                <v-col class="pa-0" style="min-width: 250px"
                  ><p class="py-3 text-subtitle-1">
                    Other Request Applied by
                    {{ roleName == "Admin" ? "Supervisors" : "Employees" }} :
                  </p></v-col
                >
              </v-row>

              <!-- Category Cards -->
              <template v-if="employee_other_requests.length > 0">
                <v-card
                  rounded="xl"
                  class="custom-border px-4 my-6"
                  elevation="10"
                  v-for="other_request in employee_other_requests"
                  :key="other_request.id"
                >
                  <!-- :to="leave" -->
                  <router-link
                    :to="`/other-requests/${other_request.id}`"
                    style="text-decoration: none"
                  >
                    <v-row align="center" class="ma-0">
                      <v-col class="pa-0">
                        <span class="text-subtitle-1 font-weight-medium">
                          Date:
                        </span>
                        <br />
                        <span
                          class="text-subtitle-1 font-weight-medium black--text"
                        >
                          {{ other_request.date }}
                        </span>
                      </v-col>

                      <v-col class="pa-0">
                        <span class="text-subtitle-1 font-weight-medium">
                          Type:
                        </span>
                        <br />
                        <span
                          class="text-subtitle-1 font-weight-medium black--text"
                        >
                          {{ other_request.type }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row align="center" class="ma-0">
                      <v-col class="pa-0">
                        <span class="text-subtitle-1 font-weight-medium">
                          Description:
                        </span>
                        <br />
                        <span
                          class="text-subtitle-1 font-weight-medium black--text"
                        >
                          {{ other_request.description }}
                        </span>
                      </v-col>
                    </v-row>
                  </router-link>
                </v-card>
              </template>
              <template v-else>
                <v-row justify="center" class="pb-6">
                  <v-col align="center">
                    <span> No Leave Applications Found.</span>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isLoading: false,
      other_requests: [],
      employee_other_requests: [],
    };
  },
  mounted() {
    if (this.roleName == "Admin") {
      this.getSupervisorData();
    } else {
      this.getData();
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let other_requests = await axios.get(`other_requests`);
      this.other_requests = other_requests.data.data;
      this.isLoading = false;
      this.getEmployeeData();
    },
    async getEmployeeData() {
      this.isLoading = true;
      let employee_other_requests = await axios.get(
        `other_requests?fetch_employees_other_request=true`
      );
      this.employee_other_requests = employee_other_requests.data.data;
      this.isLoading = false;
    },
    async getSupervisorData() {
      this.isLoading = true;
      let employee_other_requests = await axios.get(
        `other_requests?fetch_supervisors_other_request=true`
      );
      this.employee_other_requests = employee_other_requests.data.data;
      this.isLoading = false;
    },
  },
};
</script>
